(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDetailController', BrickOsfeDetailController);

    BrickOsfeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BrickOsfe'];

    function BrickOsfeDetailController($scope, $rootScope, $stateParams, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:brickOsfeUpdate', function(event, result) {
            vm.brickOsfe = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
